<div class="settings">
  <div class="settings-container">
    <h1 class="text-white">Team</h1>
  </div>
  <sa-subnav class="subnav" [subnavMenu]="subnavMenu" (onTabSwitch)="activeMenu = $event"></sa-subnav>

  <div class="content">
    <div class="drivers" *ngIf="activeMenu === subnavLabels.drivers">
      <sa-driver-settings></sa-driver-settings>
    </div>

    <div *ngIf="activeMenu === subnavLabels.users">
      <sa-user-settings></sa-user-settings>
    </div>

    <div *ngIf="activeMenu === subnavLabels.userGroups">
      <sa-user-group></sa-user-group>
    </div>

    <div *ngIf="activeMenu === subnavLabels.crews">
      <sa-crews></sa-crews>
    </div>
  </div>
</div>
